import React, { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { fetchTabaTamztitTabaData } from '../../server/ServerFunc';
import Section from '../Section';
import DataList from '../DataList';
import AppHeaderGlobal from '../AppHeaderGlobal';
import AppFooter from '../AppFooter';

const TamztitTabalInfo = ({ isSeparate }) => {
  const [tamtzitDetails, setTamtzitDetails] = useState({});
  const search = useLocation().search;

  useEffect(() => {
    const tikNumURL = new URLSearchParams(search).get("TikNum");
    getTamztitTabaContent(tikNumURL);
  }, []);

  const getTamztitTabaContent = async (tikTaba) => {
    const tamtzitData = await fetchTabaTamztitTabaData(tikTaba);

    if(Object.keys(tamtzitData).length > 0) {
      setTamtzitDetails(tamtzitData);
    } else {
      setTamtzitDetails({});
    }
  }
  
  const tamztitTabaData = [
    { key: 'shem', label: 'שם תוכנית', value: tamtzitDetails.shem },
    { key: 'status', label: 'סטטוס', value: tamtzitDetails.statusCodeText },
    { key: 'taarichStatus', label: 'תאריך', value: tamtzitDetails.taarihStatus },
    { key: 'schunaText', label: 'שכונה', value: tamtzitDetails.schunaText },
    { key: 'mitnagdim', label: 'מתנגדים', value: tamtzitDetails.mitnagdim },
    { key: 'tamztit', label: 'תמצית', value: <div dangerouslySetInnerHTML={{ __html: tamtzitDetails.tamztit }} /> }
  ]

  return (
    <>
      { isSeparate && <AppHeaderGlobal /> }
      {
        <div className="container my-3 my-lg-5">
          <Section icon={'clipboard-info'} title={'תמצית תב"ע'} id={'תמצית תב"ע'} compRender={"TamztitTaba"}>
            <DataList
              style={{ "--label-width": "140px" }}
              items={tamztitTabaData}
              columns={1}
            />
          </Section>
        </div>
      }
      { isSeparate && <AppFooter /> }
		</>
  )
}

export default TamztitTabalInfo